import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalsService } from '../../globals-services/globals.service';

@Component({
  selector: 'app-invitation-action-dialog',
  templateUrl: './invitation-action-dialog.component.html',
  styleUrls: ['./invitation-action-dialog.component.css']
})
export class InvitationActionDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<InvitationActionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private http: HttpClient,
    private globalsService: GlobalsService,



  ) { }
  ngOnInit(): void {
  }
  close() {
    this.dialogRef.close(null);

  }
  acceptConnectionInvitation() {
    let data = {
      id: this.data.invitation.id,
     
    }
    this.http.post(this.globalsService.baseHref + '/shared/thirdPartyApproveConn', data).subscribe((response) => {
      if (response) {
        this.dialogRef.close();
      }
    },
      (err) => {
        console.log(err)
      });
  }
  rejectConnectionInvitation() {
    let data = {
      id: this.data.invitation.id,
     
    }
    this.http.post(this.globalsService.baseHref + '/shared/thirdPartyRejectConn', data).subscribe((response) => {
      if (response) {
        this.dialogRef.close();
      }
    },
      (err) => {
        console.log(err)
      });
  }
  disconnection() {
    let data = {
      id: this.data.invitation.id,
    
    }
    this.http.post(this.globalsService.baseHref + '/shared/thirdPartyDisconnect', data).subscribe((response) => {
      if (response) {
        this.dialogRef.close();
      }
    },
      (err) => {
        console.log(err)
      });
  }
}
